import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateMealCategoryEntity } from '../../domain/entities/CreateUpdateMealCategoryEntity'
import type { Language } from '@/shared/entities/Language'

export class CrateUpdateMealCategoryModel extends CreateUpdateMealCategoryEntity {
  mealTierIds?: number[]
  declare translations: {
    language: Language
    name: string
    description?: string | null
  }[]
  itemIds?: Array<number> | null

  constructor(dataDto: CreateUpdateMealCategoryEntity) {
    super()
    mapEntityProperties<CrateUpdateMealCategoryModel>(this, dataDto, {
      exclude: ['mealTiers', 'items'],
      map: {
        mealTierIds: dataDto.mealTiers?.map((mealTier) => mealTier.id),
        itemIds: dataDto.items?.map((item) => item.id)
      }
    })
  }
}
